import {useCallback, useState} from "react";

/**
 * Encapsulates editor loading state so setup logic stays focused on lifecycle.
 */
export function useEditorLoading(initialLoading = false) {
    const [isLoading, setIsLoading] = useState(initialLoading);
    const [loadingStage, setLoadingStage] = useState("connecting");

    const startLoading = useCallback((stage = "connecting") => {
        setIsLoading(true);
        setLoadingStage(stage);
    }, []);

    return {
        isLoading,
        loadingStage,
        setIsLoading,
        setLoadingStage,
        startLoading,
    };
}

